import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer, Form } from '../components/common';
import { homePageContent } from '../content/homePage';
import { useContactForm } from '../utils/contactForm';
import { blogPosts } from '../data/blogPosts';
import '../components/common/PageLayout.css';
import './Blog.css';

const { form } = homePageContent;

const Blog = () => {
  const { submitStatus, handleSubmit, errorMessage } = useContactForm();

  return (
  <>
    <div className="hero-gradient-wrap">
      <Header ctaText="Join Community" ctaPath="#courses" />
      <section className="page-hero">
        <h1>Blog</h1>
        <p>Insights, tips, and updates on learning, Salesforce, and building in-demand skills.</p>
      </section>
    </div>
    <main className="page-layout-main">
      <section className="page-section">
        <h2>Latest Posts</h2>
        <p>Articles and guides from the InfinySkills team.</p>
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <Link key={post.id} to={`/blog/${post.id}`} className="blog-card blog-card-link">
              <div className="blog-card-image-wrap">
                <img src={post.image} alt="" className="blog-card-image" loading="lazy" />
                <span className="blog-card-category">{post.category}</span>
              </div>
              <div className="blog-card-body">
                <time className="blog-card-date" dateTime={post.date}>{post.date}</time>
                <h3 className="blog-card-title">{post.title}</h3>
                <p className="blog-card-excerpt">{post.excerpt}</p>
                <span className="blog-card-read-more">Read more →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <Form
        title={form.title}
        subtitle={form.subtitle}
        onSubmit={handleSubmit}
        submitStatus={submitStatus}
        errorMessage={errorMessage}
      />
    </main>
    <Footer />
  </>
  );
};

export default Blog;
